import React, { useContext } from 'react'

/**
 * pdf.js's FontLoader/CanvasFactory default to `globalThis.document` (the top-level
 * window's document) unless an `ownerDocument` is passed to `getDocument()`. When a
 * <Document>/<Page> is rendered into a react-frame-component iframe (portalled DOM,
 * same JS realm), the <canvas> lives in the iframe's document but pdf.js registers
 * embedded fonts against the parent document — the canvas can't see them, so glyphs
 * that rely on the PDF's embedded font silently render as tofu/boxes (#21567 follow-up).
 * This context lets an iframe-hosting component (e.g. PresentationImbedPreview) hand
 * its own `document` down so FilePreview can pass it through as `ownerDocument`.
 */
export const PdfOwnerDocumentContext = React.createContext<Document | undefined>(undefined)

export function PdfOwnerDocumentProvider({ document, children }: { document?: Document; children: React.ReactNode }) {
  return <PdfOwnerDocumentContext.Provider value={document}>{children}</PdfOwnerDocumentContext.Provider>
}

export const usePdfOwnerDocument = () => useContext(PdfOwnerDocumentContext)

export default PdfOwnerDocumentProvider
